<template>
  <dx-popup
    :visible="visible"
    :title="getTitle"
    :width="800"
    :height="getModelHeight"
    :showCloseButton="false"
    :dragEnabled="false"
    :resizeEnabled="false"
    @hidden="onPopupHide"
    @shown="onPopupShown"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-copy-bom',
    }"
  >
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />
    <template #content>
      <div tabindex="0" ref="mainDiv">
        <div class="current-bom css-v2 gc-popup-form">
          <gc-form
            :form-options="{
              gcLabelLocation: 'left',
            }"
            ref="gc-header-form"
            :form-items="getProductFormItems"
            :is-normal="true"
            :data-model.sync="model"
            :form-mode="'review'"
            :from-from="'gc-header-form-d-a'"
            :form-height="getFormHeight"
          >
          </gc-form>
        </div>

        <div class="new-bom css-v2 gc-popup-form">
          <gc-form
            :form-options="{
              gcLabelLocation: 'left',
            }"
            ref="gc-header-form-new-product"
            :form-items="getProductFormItems"
            :is-normal="true"
            :data-model.sync="productModel"
            :form-mode="'create'"
            :from-from="'gc-header-form-d-a'"
            :form-height="getFormHeight"
            :checkValid="isValid"
            :valueChangeCallBack="valueChangeCallBack"
          >
          </gc-form>
        </div>

        <DxLoadPanel
          :position="{ of: '#container-wrapper' }"
          :visible.sync="loadingVisible"
          :show-indicator="true"
          :show-pane="true"
          :shading="true"
          :hide-on-outside-click="false"
          shading-color="rgba(0,0,0,0.3)"
        />
      </div>
    </template>
  </dx-popup>
</template>
<script>
import { mapGetters } from "vuex";
import { ProductService } from "../../_services/api/products/product.service";
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Copy Product",
    },
    popUpConfig: {
      type: Object,
      default: () => ({}),
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    displayValidationSummary: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: () => {},
    },
    refreshList: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {
        ProductCode: "",
        Description1: "",
        Description2: "",
        Description3: "",
      },
      productModel: {
        ProductCode: "",
        Description1: "",
        Description2: "",
        Description3: "",
      },
      loadingVisible: false,
      isValid: false,
      SaveType: undefined,
    };
  },
  methods: {
    /**
     * On Popup Hide
     */
    onPopupHide() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
      this.$emit("setCopyProductVisible", false);
    },

    /**
     * On Popup Shown
     */
    async onPopupShown() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
      this.loadingVisible = true;
      this.model = { ...this.popUpConfig };

      Object.assign(this.productModel, {
        Description1: this.model.Description1,
        Description2: this.model.Description2,
        Description3: this.model.Description3,
      });

      this.$nextTick(() => {
        this.loadingVisible = false;
        this.focusOnForm();
      });
    },

    /**
     * On Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      const confirm = await this.$confirm(
        `You have unsaved changes. Are you sure you want to leave?`,
        "Unsaved changes",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      );
      if (confirm) {
        this.$emit("setCopyProductVisible", false);
      }
    },

    /**
     * Save Handler
     */
    onSaveHandler(e) {
      if (!e) return;

      const itemData = e.itemData;
      if (!itemData || !itemData.text) return;
      this.SaveType = itemData.text;
      this.isValid = true;
    },

    async valueChangeCallBack(isValid, brokenRules) {
      // const currentSaveType = this.SaveType;

      var validations = "";
      this.isValid = false;

      if (!isValid) {
        brokenRules.forEach((element) => {
          validations += `<div style="width: 400px;">${element.message}</div>`;
        });

        try {
          await this.$alert(validations, "Validation Error", {
            width: 400,
          });
        } catch (error) {
          // User might have pressed ESC, but we still need to reset
        }

        // Reset SaveType when validation fails
        this.SaveType = undefined;

        this.$nextTick(() => {
          this.$refs["mainDiv"].focus();
        });
      } else {
        this.saveCopyProduct();
      }
    },

    /**
     * Focus On Form
     */
    focusOnForm() {
      setTimeout(() => {
        this.$nextTick(() => {
          if (
            this.$refs["gc-header-form-new-product"] &&
            this.$refs["gc-header-form-new-product"].$refs["gc-form-comp"]
          ) {
            const formInstance =
              this.$refs["gc-header-form-new-product"].$refs["gc-form-comp"]
                .instance;
            if (formInstance) {
              const firstElement = formInstance.getEditor("ProductCode");

              if (firstElement) {
                firstElement.focus();
              }
            }
          }
        });
      }, 150);
    },

    async saveCopyProduct() {
      this.showLoading(true);
      try {
        const response = await ProductService.saveCopyProduct(
          this.getPayload()
        );

        if (response) {
          this.$notify("Product copied successfully.", "success");
        }

        await this.$nextTick();
        this.$store.dispatch("hotKey/setHotKeyPopupMode", false);

        if (this.SaveType === "Save & Preview") {
          this.$emit("reloadProductDetailData", this.productModel.ProductCode);

          this.$nextTick(() => {
            this.$emit("setCopyProductVisible", false);
            this.$router.push({
              name: "product-detail-review",
              params: { id: this.productModel.ProductCode },
            });
          });
        } else {
          this.$nextTick(() => {
            if (this.refreshList) {
              this.$emit("reloadProductDetailData");
            }
            this.$emit("setCopyProductVisible", false);
          });
        }
      } catch (error) {
        this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
        this.displayServerError(error);
      } finally {
        this.showLoading(false);
      }
    },

    getPayload() {
      return {
        OriginalProductCode: this.model.ProductCode,
        ProductCode: this.productModel.ProductCode,
        ProductDescription1: this.productModel.Description1,
        ProductDescription2: this.productModel.Description2,
        ProductDescription3: this.productModel.Description3,
      };
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    /**
     * Get Toolbar Items
     * @returns
     */
    getToolbarItems() {
      return [
        {
          widget: "dxDropDownButton",
          location: "after",
          toolbar: "top",
          options: {
            text: "Save",
            onItemClick: this.onSaveHandler,
            items: [
              {
                text: "Save & Preview",
              },
              {
                text: "Save",
              },
            ],
            keyExpr: "text",
            displayExpr: "text",
            showArrowIcon: true,
            dropDownOptions: {
              minWidth: 120,
            },
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
          },
        },
      ];
    },

    /**
     * Get Title
     */
    getTitle() {
      return "Copy Product";
    },

    /**
     * Get Model Height
     */
    getModelHeight() {
      return 390;
    },

    getFormHeight() {
      return 125;
    },

    /**
     * Get Product Form Items
     */
    getProductFormItems() {
      return [
        {
          itemType: "group",
          caption: "Current Product",
          colCount: 1,
          cssClass: "gc-form-group",
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  dataField: "ProductCode",
                  label: {
                    text: "Product Code",
                  },
                  editorType: "dxTextBox",
                  editorOptions: {},
                  required: true,
                },
                {
                  screenField: "Description",
                  dataField: "Description1",
                  editorOptions: {},
                },
                {
                  screenField: "Description",
                  dataField: "Description2",
                  label: {
                    text: "Description 2",
                  },
                  editorOptions: {},
                },
                {
                  screenField: "Description",
                  dataField: "Description3",
                  label: {
                    text: "Description 3",
                  },
                  editorOptions: {},
                },
              ],
            },
          ],
        },
      ];
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          this.onSaveHandler({
            itemData: {
              text: "Save & Preview",
            },
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.gc-popup-copy-bom {
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }
  .dx-toolbar-after {
    > div:first-child.dx-item.dx-toolbar-button {
      div.dx-button {
        border-radius: 2px !important;
        background-color: #03a9f4;
        color: #fff;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);
        .dx-icon.dx-icon-spindown.dx-icon-right {
          margin-left: unset !important;
          color: #fff;
        }

        .dx-icon.dx-icon-spindown.dx-icon-right::before {
          color: #fff;
        }
      }
    }
  }

  .dx-form {
    .gc-form-group {
      .dx-form-group-caption {
        font-family: Roboto;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0%;
        color: var(--colors-text-text-primary-900, #101828);
      }
    }
  }

  .new-bom {
    padding-top: unset !important;
  }

  .margin-top {
    margin-top: 10px;
  }
}
</style>
